/**
* Module to add a shipping rates calculator to cart page.
*
* Copyright (c) 2011-2016 Caroline Schnapp (11heavens.com)
* Dual licensed under the MIT and GPL licenses:
* http://www.opensource.org/licenses/mit-license.php
* http://www.gnu.org/licenses/gpl.html
* Modified by David Little, 2016
*/

"object"==typeof Countries&&(Countries.updateProvinceLabel=function(e,t){if("string"==typeof e&&Countries[e]&&Countries[e].provinces){if("object"!=typeof t&&(t=document.getElementById("address_province_label"),null===t))return;t.innerHTML=Countries[e].label;var r=jQuery(t).parent();r.find("select");r.find(".custom-style-select-box-inner").html(Countries[e].provinces[0])}}),"undefined"==typeof Shopify.Cart&&(Shopify.Cart={}),Shopify.Cart.ShippingCalculator=function(){var _config={submitButton:"Calculate shipping",submitButtonDisabled:"Calculating...",templateId:"shipping-calculator-response-template",wrapperId:"wrapper-response",customerIsLoggedIn:!1,moneyFormat:"${{amount}}"},_render=function(e){var t=jQuery("#"+_config.templateId),r=jQuery("#"+_config.wrapperId);if(t.length&&r.length){var templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var n=Handlebars.compile(jQuery.trim(t.text())),a=n(e);if(jQuery(a).appendTo(r),"undefined"!=typeof Currency&&"function"==typeof Currency.convertAll){var i="";jQuery("[name=currencies]").size()?i=jQuery("[name=currencies]").val():jQuery("#currencies span.selected").size()&&(i=jQuery("#currencies span.selected").attr("data-currency")),""!==i&&Currency.convertAll(shopCurrency,i,"#wrapper-response span.money, #estimated-shipping span.money")}}},_enableButtons=function(){jQuery(".get-rates").removeAttr("disabled").removeClass("disabled").val(_config.submitButton)},_disableButtons=function(){jQuery(".get-rates").val(_config.submitButtonDisabled).attr("disabled","disabled").addClass("disabled")},_getCartShippingRatesForDestination=function(e){var t={type:"POST",url:"/cart/prepare_shipping_rates",data:jQuery.param({shipping_address:e}),success:_pollForCartShippingRatesForDestination(e),error:_onError};jQuery.ajax(t)},_pollForCartShippingRatesForDestination=function(e){var t=function(){jQuery.ajax("/cart/async_shipping_rates",{dataType:"json",success:function(r,n,a){200===a.status?_onCartShippingRatesUpdate(r,e):setTimeout(t,500)},error:_onError})};return t},_fullAddressFromFields=function(e){var t=_addressFromFields(e);return t},_addressFromFields=function(e){return{country:jQuery("#"+e+' [name="address[country]"] option:selected').val(),province:jQuery("#"+e+' [name="address[province]"] option:selected').val(),postal_code:jQuery("#"+e+' [name="address[zip]"]').val()}},_onCartShippingRatesUpdate=function(e,t){var r=[],n=0;for(n;n<e.length;n++){var a={};a.name=e[n].name,a.value=e[n].price,a.prettify="function"==typeof Shopify.formatMoney?Shopify.formatMoney(e[n].price,_config.moneyFormat):e[n].price,r.push(a)}r.length>0&&r.sort(function(e,t){return e.value<t.value?-1:t.value<e.value?1:0});var i={rates:r,address:t};jQuery("#"+_config.wrapperId).empty(),_render(i),_enableButtons()},_onError=function(e,t){jQuery("#"+_config.wrapperId).html("<ul class='errors'><li>"+t+"</li></ul>"),_enableButtons()},_show=function(e){jQuery.extend(_config,e),jQuery("#"+_config.wrapperId).length>0&&jQuery(".get-rates").length>0&&jQuery(".get-rates").on("click",function(e){var t=jQuery(this).closest("form");e.preventDefault(),_disableButtons();var r="get-rates"===t.attr("id");_getCartShippingRatesForDestination(_fullAddressFromFields(r?"address_":t.attr("id")))})};return{show:_show,enableButtons:_enableButtons}}();

// Cart page quantity handlers with sync to side cart
jQuery(document).ready(function($) {

Shopify.Cart.ShippingCalculator.show({
submitButton: window.theme&&theme.strings&&theme.strings.shippingCalcSubmitButton?theme.strings.shippingCalcSubmitButton:"Calculate shipping",
submitButtonDisabled: window.theme&&theme.strings&&theme.strings.shippingCalcSubmitButtonDisabled?theme.strings.shippingCalcSubmitButtonDisabled:"Calculating...",
customerIsLoggedIn: !!(window.theme&&theme.strings&&theme.strings.shippingCalcCustomerIsLoggedIn),
moneyFormat: window.theme&&theme.strings&&theme.strings.shippingCalcMoneyFormat?theme.strings.shippingCalcMoneyFormat:"${{amount}}"
});

// Dispatch cart updated event for side cart to sync
function dispatchCartUpdated(cart) {
document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
if (window.jQuery) {
jQuery('body').trigger('ajaxCart.afterCartLoad', [cart]);
}
}

// Trigger cart reload on side cart when cart page quantity changes
function syncSideCart() {
// Small delay to let the cart update complete
setTimeout(function() {
fetch('/cart.js')
.then(function(r){ return r.json(); })
.then(function(c){
dispatchCartUpdated(c);
// If LSC exists, sync it too
if (window.LSC && LSC.quickLoad) {
LSC.quickLoad();
}
});
}, 300);
}

$('.qtyplus1').on('click', function(e){
e.preventDefault();
var currentVal = parseInt($(this).parent().find('input[name="updates[]"]').val());
if (!isNaN(currentVal)) {
$(this).parent().find('input[name="updates[]"]').val(currentVal + 1);
} else {
$(this).parent().find('input[name="updates[]"]').val(1);
}
$("input[name='update']").trigger("click");
// Sync side cart
syncSideCart();
});

$(".qtyminus1").on('click', function(e) {
e.preventDefault();
var currentVal = parseInt($(this).parent().find('input[name="updates[]"]').val());
if (!isNaN(currentVal) && currentVal > 0) {
$(this).parent().find('input[name="updates[]"]').val(currentVal - 1);
} else {
$(this).parent().find('input[name="updates[]"]').val(1);
}
$("input[name='update']").trigger("click");
// Sync side cart
syncSideCart();
});

// Also sync when update button is clicked
$("input[name='update']").on('click', function() {
// Give time for the cart to update
setTimeout(syncSideCart, 500);
});

// Sync when remove link is clicked
$('.cart__remove').on('click', function(e) {
// Give time for the cart to update
setTimeout(syncSideCart, 500);
});

function shippingCall() {
var x = document.getElementById("shipping-calculator-block");
if (x.style.display === "none") {
x.style.display = "block";
} else {
x.style.display = "none";
}
}


$(".cart_heading").on('click', function() {
if (jQuery(this).hasClass('clicked')) {
$(this).removeClass('clicked');
}
else
{
$(this).addClass('clicked');
}
});

});
